/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {FieldsRoutePageComponent} from './fields-route-page.component';


export function fieldsStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.dat-map.fields', {
          url: '/fields',
          views: {
            'content@app': {
              component: FieldsRoutePageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "Fields"
          }
        });
  return states.build();
}